$(function() {
  $(document).on("change", ".induction-detail-expiry-date, .induction-detail-due-date", function() {
    let expiryDate = new Date($(".induction-detail-expiry-date").val()).toLocaleString('en-AU');
    let dueDate = new Date($(".induction-detail-due-date").val()).toLocaleString('en-AU');

    if ((expiryDate && expiryDate != "Invalid Date") || (dueDate && dueDate != "Invalid Date")) {
      $.ajax({
        type: "GET",
        url:  "/induction_details/update_current_status",
        data: { expiryDate: expiryDate, dueDate: dueDate }
      });
    } else {
      $(".induction-detail-due-status").val("");
    }
  });
});
